import pnpSchema from '@yarnpkg/gatsby/static/configuration/pnp.json';
import theme from 'prism-react-renderer/themes/vsDark';
import { JsonDoc } from 'react-json-doc';
import * as React from 'react';
export default {
  pnpSchema,
  theme,
  JsonDoc,
  React
};